
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

const Main = () => {


    return (
        <>
            <Header></Header>
            <Outlet></Outlet>
            <Footer></Footer>

        </>
    );
};

export default Main;